module.exports = __webpack_public_path__ + "static/media/Internationalpic2@3x.b48f4bd6.png";